import { InjectionToken } from '@angular/core';
import {
  IPatient,
  IScribeNote,
} from '@principle-theorem/principle-core/interfaces';
import { DocumentReference, WithRef } from '@principle-theorem/shared';
import { Observable } from 'rxjs';

/**
 * The seam the floating recorder uses to insert a completed scribe note into the
 * surface currently focused on a patient (e.g. the clinical note editor). The
 * host app binds a concrete implementation; `ng-ai-scribe` never depends on the
 * charting library, so this token keeps the dependency arrow pointing inward.
 */
export interface IScribeInsertTarget {
  /**
   * The patient the active surface can accept an insert for, or `undefined` when
   * nothing is focused. The recorder only offers Insert when this patient's ref
   * matches the session's bound patient.
   */
  activeTarget$: Observable<
    { patientRef: DocumentReference<IPatient> } | undefined
  >;
  /** Insert a persisted note into the active surface. */
  insert(note: WithRef<IScribeNote>): Promise<void>;
}

/**
 * Optional injection seam consumed by `AiScribeRecorderComponent`. Absent by
 * default — when unbound the recorder simply never shows the Insert affordance.
 */
export const AI_SCRIBE_INSERT_TARGET = new InjectionToken<IScribeInsertTarget>(
  'AI_SCRIBE_INSERT_TARGET'
);
